import React, { useState } from 'react'
import Checkbox from 'react-custom-checkbox'
import * as Icon from 'react-icons/fi'
import { useEffect } from 'react'

export default function CheckBox({ onchange, checked = false, active = false, dsbl = true, item, styles = {} }) {
	const [chek, setChek] = useState(false)
	useEffect(() => {
		setChek(checked)
	}, [item])

	return (
		<div style={{ display: 'flex', width: '28px', justifyContent: 'flex-start', ...styles }}>
			{active ? (
				<Checkbox
					onChange={onchange}
					disabled={dsbl}
					checked={chek}
					borderColor='#234182'
					cursor='pointer'
					icon={<Icon.FiCheck fontWeight='700' fontSize='18' color='#174A41' size={14} />}
					color='#fff'
					containerClassName={styles.CheckBox}
					borderRadius={4}
					size={14}
				/>
			) : (
				''
			)}
		</div>
	)
}
